import React from 'react';
import { colors } from '../../utils/constants';

const Strategy = () => (
  <div className="space-y-8">
    <h2 className="text-3xl font-bold text-gray-900">Strategic Initiatives</h2>
    
    <div style={{backgroundColor: colors.blue}} className="text-white p-8 rounded-xl">
      <h3 className="font-semibold text-xl mb-4">Core Mission & Strategic Focus</h3>
      <p className="text-indigo-100 mb-4">
        Accelerate the strategic execution of Service Credit Union through venture investments that generate exceptional returns while 
        creating transformational operational efficiencies and sustainable non-interest income growth for our 375K members, with enhanced focus on military family financial services.
      </p>
      <div className=" md:grid-cols-2 gap-4 text-sm">
        <div>
          <span className="font-medium text-white">Investment Range:</span>
          <span className="text-indigo-100 ml-2">$250K-$1M initial, Pre-product through Series A</span>
        </div>
      </div>
    </div>
    
    <div className="bg-white p-8 rounded-xl border shadow-sm">
      <h3 className="text-xl font-semibold mb-6">Progress Toward $30M Annual Benefit Goal</h3>
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-gray-600">Total Efficiency Progress</span>
          <span className="text-sm font-medium text-green-600">1%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-4">
          <div className="bg-green-500 h-4 rounded-full" style={{width: '1%'}}></div>
        </div>
        <p className="text-xs text-gray-500 mt-2">
          Drive $30M in annual benefit for Service Credit Union by creating operational efficiency and generating non-interest income with investments.
        </p>
      </div>
    </div>

    <div className="bg-white p-8 rounded-xl border shadow-sm">
      <h3 className="text-xl font-semibold mb-6">New Strategic Priorities</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-indigo-500 rounded-full mt-2 flex-shrink-0"></div>
            <span className="text-sm">Implement existing solutions in the investment portfolio and generate value</span>
          </div>
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-purple-500 rounded-full mt-2 flex-shrink-0"></div>
            <span className="text-sm">Retirement programs for NH residents</span>
          </div>
        </div>
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></div>
            <span className="text-sm">Stablecoin and international payments impact</span>
          </div>
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-rose-500 rounded-full mt-2 flex-shrink-0"></div>
            <span className="text-sm">AI solutions for improving back-office operations at the credit union</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Strategy;